import React, { FC } from 'react';
import BarChart from '../BarChart';
import {
  BuiltWidgetConfig,
  OnFilterChange,
  WidgetCommonProps,
} from '../../../../gql/widget/types';
import { FilterSelection } from '../../../SimpleFilter';

type Props = {
  data: BuiltWidgetConfig;
  onFilterChange?: OnFilterChange;
  filtersVal?: FilterSelection[];
} & WidgetCommonProps;

const GroupedColumnChart: FC<Props> = (props) => {
  return <BarChart isColumn {...props} />;
};

export default GroupedColumnChart;
